import { useState, useEffect } from 'react'

import { logErrorAsync } from '../lib/utility'

export default function useLazyLoad(importLazy) {
  const [loaded, setLoaded] = useState({})
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    setLoading(true)
    importLazy
      .then((loaded) => {
        setLoaded(loaded)
        setLoading(false)
      })
      .catch((err) => {
        setLoaded({})
        setLoading(false)
        logErrorAsync(err)
      })
  }, [])

  return [loaded, loading]
}
